export default "__VITE_ASSET__ad7ffa57__"